export function isIos() {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/**
 * 判断当前设备是否为华为设备
 * 通过检测 User Agent 中是否包含 HUAWEI 或 Honor 关键字
 * @returns {boolean} true-华为设备 false-非华为设备
 */
export function isHuaWei() {
  const u = navigator.userAgent;
  return !!u.match(/HarmonyOS/i);
}

/**
 * 生成唯一值
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = ((1 + Math.random()) * 65536).toFixed(0) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * 时间戳格式化函数
 * eg: timestampFormat('YYYY/mm/dd', 毫秒精度的时间戳);
 * @param  {string} fmt    格式
 * @param  {int}  time 要格式化的时间
 * @return {string}  格式化的时间字符串
 */
export function timestampFormat(fmt, timestamp) {
  return dateFormat(fmt, new Date(timestamp))
}

/**
 * 日期格式化函数
 * eg: dateFormat('YYYY/mm/dd', new Date());
 * @param  {string} fmt    格式
 * @param  {Date}    date 要格式化的时间 默认为当前时间
 * @return {string}           格式化的时间字符串
 */
export function dateFormat(fmt, date = new Date()) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    };
  };
  return fmt;
}
/**
 * 时间戳转xx小时前/xx分钟前格式
 * @param {*} time 
 * @returns String 
 */
export function timeFormat(time) {
  let curTime = parseInt(new Date().getTime()/1000)
  let disTime = curTime-time
  if(disTime<60){
    return '刚刚'
  }else if(disTime<60*60){
    return parseInt(disTime/60)+'分钟前'
  }else if(disTime<60*60*24){
    return parseInt(disTime/3600)+'小时前'
  }
  let date = new Date(time*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let year = date.getFullYear(),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      sdate = ("0" + date.getDate()).slice(-2),
      hour = ("0" + date.getHours()).slice(-2),
      minute = ("0" + date.getMinutes()).slice(-2),
      second = ("0" + date.getSeconds()).slice(-2);
  // 拼接
  let result = year + "-"+ month +"-"+ sdate;
  // 返回
  return result;
}

export function getHeaderInfo() {
  const userAgentinfo = window.navigator.userAgent
  let headerinfo = {}
  if (userAgentinfo.indexOf('Android') > -1) {
      headerinfo = {
          'client_id': 'gkztcandroid',
          'client_secret': 'root4gkztc'
      }
  } else if (userAgentinfo.indexOf('ios') > -1) {
      headerinfo = {
          'client_id': 'gkztcios',
          'client_secret': 'ios4gkztc'
      }
  } else if(userAgentinfo.toLowerCase().indexOf('micromessenger') > -1){
      headerinfo = {
          'client_id': 'gkztcweb',
          'client_secret':'web4gkztc'
      }
  } else {
      headerinfo = {
          'client_id': 'gkztcweb',
          'client_secret':'web4gkztc'
      }
  }
  return headerinfo
}

/**
 * 判断中国手机号
 * @returns {string}
 */
export function validatePhoneNumber(phoneNumber) {
  // 中国的手机号以1开头，总共11位
  const regex = /^1[3-9]\d{9}$/;
  return regex.test(phoneNumber);
}

// 大于等于当年的8月10号时返回第二年，小于时返回当年
export function getCurrentYear() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const month = today.getMonth() + 1; // getMonth() 返回的月份是从0开始的，所以需要加1
  const day = today.getDate();

  // 判断是否大于等于8月10号
  if (month >= 8 && day >= 10) {
      return currentYear + 1;
  } else {
      return currentYear;
  }
}

/**
 * 异步复制文本到剪贴板
 * @param {String} text 要复制的文本
 * @returns {Promise<Boolean>} 是否复制成功
 */
export async function copyText(text) {
  // 校验内容
  if (!text || typeof text !== 'string') {
    throw new Error('复制内容不能为空');
  }

  // 优先使用标准 API（iOS 13+ / 安卓）
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // 标准 API 失败，降级到 input 方案
      console.warn('标准 API 失败，尝试降级方案：', err);
    }
  }

  // 降级方案（兼容 iOS 13 以下 / 非 HTTPS 环境）
  const input = document.createElement('input');
  input.value = text;
  input.style.position = 'absolute';
  input.style.top = '-9999px';
  input.style.left = '-9999px';
  document.body.appendChild(input);

  try {
    input.select();
    input.setSelectionRange(0, text.length); // 兼容移动设备
    const success = document.execCommand('copy');
    if (!success) throw new Error('降级方案复制失败');
    return true;
  } catch (err) {
    throw err;
  } finally {
    document.body.removeChild(input);
  }
}

// 是否在app
export const inApp = () => {
  var ua = navigator.userAgent.toLowerCase()
  if(ua.indexOf('gkztc')> -1){
    return true
  }else{
    return false
  }
}

// 是否在微信小程序/支付宝小程序
export const isMiniprogram = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("miniprogram") != -1||ua.indexOf("alipayclient") != -1;
}

// 春季高考 跳转
// type:  0：学考 1： 3+证书
export const toSpringIndex = (platform=0) => {
  if (inApp()) {
    location.href = `gkztc://spring/index?type=${platform == 1 ? '3plus' : 'xuekao'}`
  } else if (isMiniprogram()) {
    wx.miniProgram.switchTab({ url: '/pages/index/index' })
  } else {
    if (platform == 1) {
      location.href = 'https://app.gaokaozhitongche.com/l/mincjgk?path=pages%2Findex%2Findex%26query%3Dplatform%3D1'
    } else {
      location.href = 'https://app.gaokaozhitongche.com/l/mincjgk?path=pages/index/index'
    }
  }
}